import { DEFAULT_SITE } from './siteDefaults';

function strPrefer(a, b, fallback = '') {
  if (typeof a === 'string' && a.trim()) return a.trim();
  if (typeof b === 'string' && b.trim()) return b.trim();
  return typeof fallback === 'string' ? fallback : '';
}

function defaultMilestones() {
  const m = DEFAULT_SITE.history?.timeline?.milestones;
  return Array.isArray(m) ? m.map((row) => ({ ...row })) : [];
}

function normalizeMilestoneRow(raw, fallbackRow) {
  if (!raw || typeof raw !== 'object') return fallbackRow ? { ...fallbackRow } : null;
  const year = typeof raw.year === 'string' ? raw.year.trim() : raw.year != null ? String(raw.year).trim() : '';
  const title = typeof raw.title === 'string' ? raw.title.trim() : '';
  const body = typeof raw.body === 'string' ? raw.body.trim() : '';
  const image = typeof raw.image === 'string' ? raw.image.trim() : '';
  const imageAlt = typeof raw.imageAlt === 'string' ? raw.imageAlt.trim() : '';
  if (!year || !title) return null;
  return {
    year,
    title,
    body: body || (fallbackRow && fallbackRow.body) || '',
    image: image || (fallbackRow && fallbackRow.image) || '',
    imageAlt: imageAlt || (fallbackRow && fallbackRow.imageAlt) || '',
  };
}

function resolveTimelineMilestones(site) {
  const defaults = defaultMilestones();
  const apiList = site?.history?.timeline?.milestones;
  if (!Array.isArray(apiList) || apiList.length === 0) {
    return defaults;
  }
  const out = [];
  for (let i = 0; i < apiList.length; i++) {
    const row = normalizeMilestoneRow(apiList[i], defaults[i]);
    if (row) out.push(row);
  }
  return out.length ? out : defaults;
}

function resolveInternal(site) {
  const d = DEFAULT_SITE.history?.internal && typeof DEFAULT_SITE.history.internal === 'object' ? DEFAULT_SITE.history.internal : {};
  const a =
    site?.history?.internal && typeof site.history.internal === 'object' ? site.history.internal : {};
  const bulletsFromApi = Array.isArray(a.bullets) ? a.bullets.map((b) => (typeof b === 'string' ? b.trim() : '')).filter(Boolean) : [];
  const bulletsFromDefault = Array.isArray(d.bullets)
    ? d.bullets.map((b) => (typeof b === 'string' ? b.trim() : '')).filter(Boolean)
    : [];
  const bullets = bulletsFromApi.length ? bulletsFromApi : bulletsFromDefault;

  return {
    eyebrow: strPrefer(a.eyebrow, d.eyebrow, 'Behind the brand'),
    title: strPrefer(a.title, d.title, 'Internal Rafidseed'),
    body: strPrefer(
      a.body,
      d.body,
      'This is how we run day to day: disciplined operations, shared accountability, and a culture that treats every bag of seed as if it were going to our own fields.'
    ),
    image: strPrefer(a.image, d.image, ''),
    imageAlt: strPrefer(a.imageAlt, d.imageAlt, 'Rafid Seeds leadership and internal collaboration'),
    caption: strPrefer(
      a.caption,
      d.caption,
      'People, process, and pride—how we work when the world is not watching.'
    ),
    bullets,
  };
}

function resolveTimelineMeta(site) {
  const d = DEFAULT_SITE.history?.timeline && typeof DEFAULT_SITE.history.timeline === 'object' ? DEFAULT_SITE.history.timeline : {};
  const t = site?.history?.timeline && typeof site.history.timeline === 'object' ? site.history.timeline : {};
  return {
    eyebrow: strPrefer(t.eyebrow, d.eyebrow, 'Our story unfolds'),
    title: strPrefer(t.title, d.title, 'Our revolution—in seed, trust, and the field'),
    intro: strPrefer(
      t.intro,
      d.intro,
      'Not overnight fame—steady work: better germplasm, honest labels, and teams who show up for growers in every season.'
    ),
    milestones: resolveTimelineMilestones(site),
  };
}

/**
 * Public History page + admin: merge CMS `site.history` with packaged defaults (same idea as `resolveAbout`).
 */
export function resolveHistory(site) {
  const d = DEFAULT_SITE.history && typeof DEFAULT_SITE.history === 'object' ? DEFAULT_SITE.history : {};
  const h = site?.history && typeof site.history === 'object' ? site.history : {};
  const timeline = resolveTimelineMeta(site);

  return {
    pageHeroImage: strPrefer(h.pageHeroImage, d.pageHeroImage, ''),
    heroTitle: strPrefer(h.heroTitle, d.heroTitle, 'Our History'),
    heroBreadcrumbHome: strPrefer(h.heroBreadcrumbHome, d.heroBreadcrumbHome, 'Home'),
    heroBreadcrumbCurrent: strPrefer(h.heroBreadcrumbCurrent, d.heroBreadcrumbCurrent, 'History'),
    internal: resolveInternal(site),
    timeline,
  };
}
